export default "__VITE_ASSET__DM51Z75t__"